export default __webpack_public_path__ + "static/ogp-image-a66d3c5fc41ce617f7d54c791d8064b5.jpg";